import { ButtonArrow } from "@/components/atoms/ButtonArrow";
import type { TTestimonialButtons } from "./types";
import { buttonsPositions } from "./variables";

export const TestimonialButtons = ({
  leftButton,
  rightButton,
}: TTestimonialButtons) => {
  const TestimonialButtonsElement = document.createElement("div");
  TestimonialButtonsElement.className = "flex items-center";

  const props = {
    left: leftButton,
    right: rightButton,
  };

  buttonsPositions.forEach((direction) => {
    TestimonialButtonsElement.appendChild(
      ButtonArrow({
        direction,
        ...props[direction],
      }),
    );
  });

  return TestimonialButtonsElement;
};
